<template>
  <div>
    <section class="content-header">
      <h1>My Wallet</h1>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-xl-4">
          <wallet></wallet>
        </div>

        <div class="col-12 col-sm-8 col-md-8 col-xl-8">
          <div class="cyber-form-card">
            <div class="cyber-form-card__glow"></div>
            <div class="cyber-form-card__header">
              <i class="mdi mdi-send"></i>
              <h4>Request a Withdrawal</h4>
            </div>
            <div class="cyber-form-card__body">
              <form @submit.prevent="createWithdrawal">
                <div class="form-group">
                  <label>Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-dollar pl-5 pr-3"></i>
                    </span>
                    <input
                      v-model="model.value"
                      class="form-control"
                      type="number"
                      value="0"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    {{ (model.withdrawal_type === "regular" && "USDT Wallet") || "bbusiness Username" }}
                  </label>
                  <router-link
                    v-if="model.withdrawal_type === 'regular'"
                    class="float-right"
                    style="color: #7BC88F !important; font-size: 0.8rem;"
                    :to="{ name: 'Profile.dashboard' }"
                  >(Edit Here)</router-link>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <template v-if="model.withdrawal_type === 'regular'">
                        <cryptoicon symbol="usdt" size="25" />
                      </template>
                      <template v-else>
                        <img src="/images/icon.jpg" class="eleven-icon" />
                      </template>
                    </span>
                    <template v-if="model.withdrawal_type === 'transfer'">
                      <input
                        class="form-control"
                        type="text"
                        v-model="model.receiver_user"
                      />
                    </template>
                    <template v-else>
                      <input
                        :disabled="true"
                        class="form-control"
                        type="text"
                        v-model="model.wallet"
                      />
                    </template>
                  </div>
                </div>

                <div class="form-group">
                  <label>Withdraw Type</label>
                  <select
                    class="form-control"
                    v-model="model.withdrawal_type"
                  >
                    <option :value="'regular'">Crypto Network</option>
                  </select>
                </div>

                <div class="form-group">
                  <email-auth-code
                    @code-changed="(evt) => (model.email_auth_code = evt)"
                    labelClass="col-sm-12"
                    inputClass="col-sm-12"
                  />
                </div>

                <div class="cyber-form-card__notice">
                  <i class="mdi mdi-information-outline"></i>
                  <div>
                    <strong>Requests</strong>
                    <p>All requests must be greater than $100 and equal or less than your balance.</p>
                  </div>
                </div>

                <button
                  type="submit"
                  class="btn btn-success btn-block"
                  v-if="!loading"
                >
                  Request Now
                  <i class="mdi mdi-send ml-2"></i>
                </button>
                <button type="submit" class="btn btn-success btn-block" v-else disabled>
                  Loading
                  <i class="fa fa-circle-o-notch fa-spin ml-2"></i>
                </button>
              </form>
            </div>
          </div>
          <withdrawal-details />
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.cyber-form-card {
  background: #252525;
  border: 1px solid #3d3d37;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
}

.cyber-form-card__glow {
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, transparent);
}

.cyber-form-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px;
  border-bottom: 1px solid #3d3d37;
}

.cyber-form-card__header i {
  color: #B09A4E;
  font-size: 1.3rem;
}

.cyber-form-card__header h4 {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.8rem !important;
  color: #E0DFD8 !important;
  margin: 0 !important;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cyber-form-card__body {
  padding: 20px;
}

.cyber-form-card__notice {
  display: flex;
  gap: 10px;
  padding: 12px 15px;
  background: rgba(176, 154, 78, 0.05);
  border: 1px solid rgba(176, 154, 78, 0.1);
  border-radius: 10px;
  margin-bottom: 20px;
}

.cyber-form-card__notice i {
  color: #B09A4E;
  font-size: 1.2rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.cyber-form-card__notice strong {
  color: #B09A4E;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

.cyber-form-card__notice p {
  color: #9A998F;
  font-size: 0.8rem;
  margin: 3px 0 0;
}
</style>

<script>
import WithdrawalDetails from "@/views/Withdrawals/Details";
import { EmailAuthCode } from "@/components";
import Wallet from "@/components/Wallet";

export default {
  name: "balance",
  data() {
    return {
      model: {
        value: 0,
        fees: 0,
        total: 0,
        currency_id: 11,
        withdrawal_type: "regular",
        wallet: this.$store.getters["currentUser"].token_wallet,
        receiver_user: "",
      },
      loading: false,
    };
  },
  components: { EmailAuthCode, WithdrawalDetails, Wallet },
  watch: {
    "model.value": function (oldValue) {
      this.model.fees = (parseFloat(oldValue).toFixed(2) * 0.05).toFixed(2);
      this.model.total = (parseFloat(oldValue).toFixed(2) * 0.95).toFixed(2);
    },
    "model.withdrawal_type": function (newValue) {
      if (newValue === "regular")
        this.model.wallet = this.$store.getters["currentUser"].token_wallet;
      if (newValue === "transfer") this.model.wallet = "";
    },
  },
  methods: {
    createWithdrawal() {
      this.loading = true;
      this.$http({
        method: "post",
        url: "/api/v1/client/withdrawals",
        data: this.model,
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then(() => {
          this.$store.dispatch("getUser");
          this.$store.dispatch("getWithdrawals");
          this.$toasted.show("Withdrawal requested!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.errors.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
</script>
